import React, { useState, useEffect } from "react";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import UnlockPage from "./pages/UnlockPage";
import NavigationContext from "./components/NavigationContext";
import HttpService from "./sdk/HttpAxios";

function App() {
  const [currentPage, setCurrentPage] = useState("home");
  const [phone, setPhone] = useState("");
  const [disableHome, setDisableHome] = useState(false);

  /**
   * Handle refresh / deep link:
   *  - /unlock?terminal=xxx
   */
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const terminal = params.get("terminal");

    if (window.location.pathname === "/unlock" && terminal) {
      setCurrentPage("unlock");
    } else {
      setCurrentPage("home");
    }
  }, []);

  /**
   * SPA-safe navigation to unlock page
   */
  const navigateToUnlock = () => {
    setCurrentPage("unlock");

    window.history.pushState({}, "", `/unlock`);
  };

  /**
   * Navigate home
   */
  const navigateHome = () => {
    setCurrentPage("home");
    window.history.pushState({}, "", `/`);
  };

  /**
   * Handle login flow: request OTP and then verify
   * onNext is called from the login page with an object
   * containing phone and optionally otp.
   */
  const onLogin = async ({ phone: phoneNumber, otp }) => {
    const http = new HttpService();
    if (!otp) {
      // first step: request OTP
      await http.loginWithOtp(phoneNumber);
      setPhone(phoneNumber);
      // remain on login page, let the page show OTP input
      return;
    }

    // second step: verify OTP and navigate
    await http.loginWithOtp(phoneNumber, otp);
    setPhone(phoneNumber);
    navigateToUnlock();
  };

  console.log("currentPage: ", currentPage);

  return (
    <NavigationContext.Provider
      value={{
        navigateHome,
        disableHome,
        setDisableHome,
      }}
    >
      {currentPage === "" && <>Loading…</>}

      {/* 1️⃣ Instructions */}
      {currentPage === "home" && (
        <HomePage onNext={() => setCurrentPage("login")} />
      )}

      {/* 2️⃣ Login / OTP */}
      {currentPage === "login" && <LoginPage onNext={onLogin} />}

      {/* 3️⃣ Unlock */}
      {currentPage === "unlock" && <UnlockPage />}
    </NavigationContext.Provider>
  );
}

export default App;
